import React from 'react';
import { Icon } from '@iconify/react';

const ProjectCard = ({ project, isHovered }) => {
  return (
    <div
      className="group relative bg-white dark:bg-neutral-900/50 
        rounded-2xl border border-neutral-200 dark:border-neutral-800
        backdrop-blur-sm overflow-hidden
        transform transition-all duration-500
        hover:scale-[1.02] hover:shadow-2xl hover:shadow-purple-500/20
        hover:border-purple-300 dark:hover:border-purple-700"
    >
      {/* Gradient Background on Hover */}
      <div
        className={`absolute inset-0 bg-gradient-to-br ${project.gradient}
          opacity-0 group-hover:opacity-5 transition-opacity duration-500`}
      />

      {/* Card Content */}
      <div className="relative p-6">
        {/* Icon Header */}
        <div className="flex items-start justify-between mb-4">
          <div
            className={`w-14 h-14 rounded-xl bg-gradient-to-br ${project.gradient}
              flex items-center justify-center
              transform transition-all duration-500
              group-hover:scale-110 group-hover:rotate-6
              shadow-lg`}
          >
            <Icon icon={project.icon} className="w-7 h-7 text-white" />
          </div>

          {project.github && (
            <a
              href={project.github}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-neutral-100 dark:bg-neutral-800
                flex items-center justify-center
                transform transition-all duration-300
                hover:scale-110 hover:bg-neutral-200 dark:hover:bg-neutral-700
                opacity-0 group-hover:opacity-100"
            >
              <Icon icon="mdi:github" className="w-5 h-5 text-neutral-700 dark:text-neutral-300" />
            </a>
          )}
        </div>

        {/* Category Badge */}
        <span
          className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3
            bg-gradient-to-r ${project.gradient} bg-opacity-10 text-transparent bg-clip-text`}
          style={{
            backgroundColor: 'rgba(139, 92, 246, 0.1)',
            color: 'inherit'
          }}
        >
          <span className={`bg-gradient-to-r ${project.gradient} bg-clip-text text-transparent`}>
            {project.category}
          </span>
        </span>

        {/* Title */}
        <h3
          className="text-xl font-bold text-neutral-900 dark:text-neutral-100 mb-3
            group-hover:bg-gradient-to-r group-hover:from-violet-600 group-hover:to-fuchsia-600 
            group-hover:bg-clip-text group-hover:text-transparent transition-all duration-300"
        >
          {project.title}
        </h3>

        {/* Description */}
        <p className="text-neutral-600 dark:text-neutral-400 text-sm leading-relaxed mb-4">
          {project.description}
        </p>

        {/* Highlights - On Hover */}
        <div
          className={`space-y-2 mb-4 transition-all duration-500 overflow-hidden
            ${isHovered ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
        >
          {project.highlights.map((highlight, i) => (
            <div key={i} className="flex items-start gap-2">
              <Icon icon="mdi:check-circle" className="w-4 h-4 text-purple-500 mt-0.5 flex-shrink-0" />
              {/* Use a lighter text color here too */}
              <span className="text-xs text-neutral-500 dark:text-neutral-400">{highlight}</span>
            </div>
          ))}
        </div>

        {/* Tech Stack */}
        <div className="flex flex-wrap gap-2">
          {project.tech.map((tech, i) => (
            <span
              key={i}
              className="px-3 py-1 rounded-full text-xs font-medium
                bg-neutral-100 dark:bg-neutral-800
                text-neutral-700 dark:text-neutral-300
                border border-neutral-200 dark:border-neutral-700"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>

      {/* Bottom Accent Line */}
      <div
        className={`h-1 bg-gradient-to-r ${project.gradient}
          transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500
          origin-left`}
      />
    </div>
  );
};

export default ProjectCard;